import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Button, Modal} from 'react-bootstrap';
import {actions, LocalForm} from 'react-redux-form';

import {getTokens} from '../../actions/tokens';
import SnippetAttributes from './SnippetAttributes';
import ValidationErrors from '../forms/ValidationErrors';
import FroalaEditor from 'froala-editor';

import './styles/snippet_editor.scss';

class SnippetEditor extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    htmlAllowDangerousTags: PropTypes.bool,
    onClose: PropTypes.func,
    initialFormState: PropTypes.object,
    item: PropTypes.object,
    fields: PropTypes.array,
    showFormatting: PropTypes.bool,
    froalaOptions: PropTypes.object
  };

  static defaultProps = {
    fields: [],
    froalaOptions: {},
    htmlAllowDangerousTags: false,
    initialFormState: {},
    item: {},
    showFormatting: true
  };

  constructor(props) {
    super(props);

    const {item : snippet} = this.props;

    this.state = {
      errors: {}
    };

    this.initialFormState = Object.assign({
      snippet: snippet,
      tokenSelector: {
        category: 'contact'
      }
    }, props.initialFormState);
  }

  render() {
    const {
      fields,
      froalaOptions,
      handleSubmit,
      htmlAllowDangerousTags,
      onClose,
      showFormatting,
      item : snippet,
      ready,
      copy
    } = this.props;

    let fieldNames = {};

    fields.forEach((field) => {
      if (!React.isValidElement(field)) {
        fieldNames[field.canonicalName] = field.displayName;
      }
    });

    // Manually add body to the field names
    fieldNames['body'] = 'Body';


    return (
      <Modal show className='snippet-editor-modal' backdrop='static' keyboard={false}>
        <LocalForm
          getDispatch={(dispatch) => this.formDispatch = dispatch}
          initialState={this.initialFormState}
          onSubmit={
            (values) => {
              let defaultAttributes = {};
              let newSnippet = Object.assign({}, values.snippet, defaultAttributes);
              this.setState({ isLoading: true });

              delete (newSnippet['tokens']);

              handleSubmit(newSnippet)
                .then(() => onClose())
                .catch((response) => {
                  const errors = Object.assign({}, response);

                  // Can't control it; don't care about it
                  delete (errors['canonical_name']);
                  delete (errors['response']);

                  this.setState({ errors: errors, isLoading: false })
                });
            }
          }
        >

          <Modal.Header>
            <h1 className='modal-title' style={{ display: 'inline-block' }}>Edit Template</h1>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
          </Modal.Header>
          <Modal.Body>
            {!!Object.keys(this.state.errors).length && <ValidationErrors
              errors={this.state.errors}
              fieldNames={fieldNames}
            />}
            {copy && <div className={'editor-info-text'}>This draft has been copied from an existing template. Enter a name and click the <span className={'bold'}>Save</span> button below to save it as a new template.</div>}
            <SnippetAttributes
              fields={fields}
              snippet={snippet}
              prefix="local.snippet"
              htmlAllowDangerousTags={htmlAllowDangerousTags}
              showFormatting={showFormatting}
              froalaOptions={{
                scrollableContainer: '.snippet-editor-modal',
                ...froalaOptions}}
              ready={ready}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button className="me-2" onClick={onClose} variant="light">Close</Button>
            <Button disabled={this.state.isLoading} variant="primary" type="submit">Save</Button>
          </Modal.Footer>
        </LocalForm>
      </Modal>
    )
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {item : snippet} = nextProps;

    if (Object.keys(snippet).length) {
      // If there's a snippet, use its content

      this.formDispatch(actions.merge('local.snippet', snippet));
    }
  }

  componentDidMount() {
    const {dispatch, item : snippet, type} = this.props;
    // use the snippet class if we have it, otherwise use the type prop
    const snippetType = snippet.type ? snippet.type.replace('Snippet',"") : type;
      dispatch(getTokens(snippetType)).then((response) => {
        this.formDispatch(
          actions.merge(`local.snippet.tokens`, response.tokens)
        );
      });
  }
}

const mapStateToProps = (state) => {
  return {
    customer: state.customer.object,
    customerIsLoading: state.customer.isLoading
  };
};

export const MMS_FROALA_OPTIONS = {
  charCounterCount: true,
  charCounterMax: 320,
  enter: FroalaEditor.ENTER_BR,
  pastePlain: true,
  imagePaste: false
};

export default connect(mapStateToProps)(SnippetEditor);
